import { createSelector, createStructuredSelector } from 'reselect';
import { dataDomain, loaderDomain } from './domains';

const initialDataSelect = createSelector(dataDomain, (data) => data);

export const showLoaderSelect = createSelector(loaderDomain, (loader) => !!loader.length);

const hideBackgroundSelect = createSelector(loaderDomain, (loader = []) =>
  loader.some((item) => item.startsWith('CRITICAL'))
);

export const isProfileDeprecatedSelect = createSelector(
  dataDomain,
  ({ isProfileDeprecated }) => !!isProfileDeprecated
);

export const isChargingEnabledSelect = createSelector(
  dataDomain,
  ({ isChargingEnabled }) => !!isChargingEnabled
);

export const isLootBoxEnabledSelect = createSelector(
  dataDomain,
  ({ isLootBoxEnabled }) => !!isLootBoxEnabled
);

export const isCNEnvSelect = createSelector(dataDomain, ({ isCNEnv }) => !!isCNEnv);

export const isProdEnvSelect = createSelector(dataDomain, ({ isProdEnv }) => !!isProdEnv);

export default createStructuredSelector({
  initialData: initialDataSelect,
  showLoader: showLoaderSelect,
  hideBackground: hideBackgroundSelect,
  isProfileDeprecated: isProfileDeprecatedSelect,
  isLootBoxEnabled: isLootBoxEnabledSelect,
  isCNEnv: isCNEnvSelect,
});
